import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { cn } from '@/lib/html/class-name'

export function ErrorMessage({
  title,
  message,
  children,
  className,
  descriptionClassName,
}: {
  title?: string | React.ReactNode
  message?: string | React.ReactNode
  children?: React.ReactNode
  className?: string
  descriptionClassName?: string
}) {
  return (
    <Alert variant="destructive" className={className}>
      {title && (
        <AlertTitle className={cn('text-sm font-medium', !!message && 'mb-1')}>
          {title}
        </AlertTitle>
      )}
      {message && (
        <AlertDescription className={cn('text-sm font-small', descriptionClassName)}>
          {message}
        </AlertDescription>
      )}
      {children && (
        <AlertDescription className={descriptionClassName}>{children}</AlertDescription>
      )}
    </Alert>
  )
}

export function DefaultMessage({
  title,
  message,
  children,
  className,
  descriptionClassName,
}: {
  title?: string | React.ReactNode
  message?: string | React.ReactNode
  children?: React.ReactNode
  className?: string
  descriptionClassName?: string
}) {
  return (
    <Alert variant="default" className={className}>
      {title && (
        <AlertTitle className={cn('text-sm font-medium', !!message && 'mb-1')}>
          {title}
        </AlertTitle>
      )}
      {message && (
        <AlertDescription className={cn('text-sm font-small', descriptionClassName)}>
          <p className="whitespace-normal">{message}</p>
        </AlertDescription>
      )}
      {children && (
        <AlertDescription className={descriptionClassName}>{children}</AlertDescription>
      )}
    </Alert>
  )
}

export function SuccessMessage({
  title,
  message,
  children,
  className,
  descriptionClassName,
}: {
  title?: string | React.ReactNode
  message?: string | React.ReactNode
  children?: React.ReactNode
  className?: string
  descriptionClassName?: string
}) {
  return (
    <Alert variant="primary" className={className}>
      {title && (
        <AlertTitle className={cn('text-sm font-medium', !!message && 'mb-1')}>
          {title}
        </AlertTitle>
      )}
      {message && (
        <AlertDescription className={cn('text-sm font-small', descriptionClassName)}>
          <p className="whitespace-normal">{message}</p>
        </AlertDescription>
      )}
      {children && (
        <AlertDescription className={descriptionClassName}>{children}</AlertDescription>
      )}
    </Alert>
  )
}
